import { useState } from "react";
import type { ReactNode } from "react";
import { Card, Box } from "@mui/material";
import ImageZoomModal from "components/inputs/photos/ImageZoomModal";
import DeleteButton from "./DeleteButton";
import PhotoImage from "./PhotoImage";

type PhotoInputProps = {
  base64String?: string | null;
  isLoading?: boolean;
  readOnly?: boolean;
  deleteImage: () => void;
  selectImage: () => void;
};

function PhotoInput({
  base64String,
  isLoading = false,
  readOnly = false,
  deleteImage,
  selectImage,
}: Readonly<PhotoInputProps>): ReactNode {
  const [openZoomModal, setOpenZoomModal] = useState<boolean>(false);

  function handleClick(): void {
    if (isLoading) return;

    if (base64String != null && base64String !== "") {
      setOpenZoomModal(true);
    } else if (!(readOnly ?? false)) {
      selectImage();
    }
  }

  const responsiveBorder = {
    bgcolor: "#F2F2F2",
    border: { xs: "2px dashed #4B515D", sm: "3px dashed #4B515D" },
  };

  return (
    <Card
      variant="outlined"
      sx={base64String != null && base64String !== "" ? {} : responsiveBorder}>
      <Box
        sx={{
          position: "relative",
          height: "100%",
          width: "100%",
        }}>
        <PhotoImage
          base64String={base64String}
          isLoading={isLoading}
          readOnly={readOnly}
          onClick={handleClick}
        />
        {!readOnly && base64String != null && base64String !== "" && (
          <DeleteButton onClick={deleteImage} />
        )}
      </Box>
      <ImageZoomModal
        altText="Image illustrant les circonstances de l'accident"
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        src={base64String!}
        open={openZoomModal}
        setOpen={setOpenZoomModal}
      />
    </Card>
  );
}

export default PhotoInput;
